<template>
  <v-expansion-panels class="fila1">
    <v-expansion-panel v-if="meeting">
      <v-expansion-panel-title>Datos de la reunión</v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field label="Nombre" v-model="meeting.name" @keyup.enter="updateMeeting" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Descripción" v-model="meeting.description" @keyup.enter="updateMeeting" />
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-if="isAnfitrion" :items="users" label="Anfitrión" v-model="anfitrion"
                @change="updateRole('anfitrion', meeting.anfitrion)"></v-select>
              <v-text-field v-else label="Anfitrión" v-model="meeting.anfitrion" readonly></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-if="isAnfitrion" :items="users" label="Secretario" v-model="secretario"
                @change="updateRole('secretario', meeting.secretario)"></v-select>
              <v-text-field v-else label="Secretario" v-model="meeting.secretario" readonly></v-text-field>
            </v-col>
          </v-row>
          <v-divider>Horario planificado</v-divider>
          <v-row>
            <v-col cols="4">
              <v-text-field v-model="meeting.fecha" label="Fecha" :value="formattedDate(meeting.fecha)" readonly></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field label="Hora de inicio" v-model="meeting.horaInicio" readonly></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field label="Hora de finalización" v-model="meeting.horaFinal" readonly></v-text-field>
            </v-col>
          </v-row>
          <template v-if="['in-meeting', 'post-meeting', 'finished'].includes(state)">
            <v-divider>Horario real</v-divider>
            <v-row>
              <v-col cols="4">
                <v-text-field label="Fecha" :model-value="formatDateTimeToDate(meetingMinute.realStartTime)" readonly></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Hora de inicio" :model-value="formatDateTimeToTime(meetingMinute.realStartTime)" readonly></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field label="Hora de finalización" :model-value="formatDateTimeToTime(meetingMinute.realEndTime)" readonly></v-text-field>
              </v-col>
            </v-row>
          </template>
          <v-divider></v-divider>
          <h3>Participantes</h3>
          <v-list>
            <v-list-item v-for="(user, index) in meeting.invitados" :key="index" class="participant-item">
              <v-list-item-content>
                <v-list-item-title>{{ user }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="isAnfitrion">
                <v-btn icon @click="removeParticipant(user)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import api from '@/api.js';
import { formatDateTimeToDate, formatDateTimeToTime } from '@/utils/globalFunctions';

export default {
  name: "MeetingDataComponent",
  props: {
    currentUser: {
      type: String,
      required: true,
    },
    meetingMinute: {
      type: Object,
      required: true,
    },
    state: {
      type: String,
      required: true,
    }
  },
  computed: {
    isAnfitrion() {
      const result = this.meeting.anfitrion === localStorage.getItem('email');
      return result;
    },
    meeting() {
      return this.$store.state.meeting || {};
    },
    secretario: {
      get() {
        return this.meeting.secretario;
      },
      set(value) {
        this.updateRole('secretario', value);
      }
    },
    anfitrion: {
      get() {
        return this.meeting.anfitrion;
      },
      set(value) {
        this.updateRole('anfitrion', value);
      }
    },
    users() {
      return this.$store.state.meeting?.invitados || [];
    },
  },
  methods: {
    formattedDate(date) {
      // Parametro date de tipo Date o string ISO
      /*
      const d = new Date(date);
      return d.getDate().toString().padStart(2, '0') + '/' +
        (d.getMonth() + 1).toString().padStart(2, '0') + '/' +
        d.getFullYear().toString();
      */

      // Parámetro de tipo string dd/mm/aa (solo reemplaza los guiones por barras)
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    formatDateTimeToTime(datetime){
      formatDateTimeToTime(datetime);
    },
    formatDateTimeToDate(datetime){
      formatDateTimeToDate(datetime);
    },
    async updateRole(role, user) {
      // TODO: Implementarlo como evento de websocket
      this.$store.commit('updateMeeting', {
        [role]: user,
      });

      try {
        await api.put(`/api/meeting/${this.meeting._id}`, {
          [role]: user,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        window.location.reload();
      } catch (error) {
        console.error('Error al actualizar el rol:', error);
      }
    },
    async updateMeeting() {
      this.$store.commit('updateMeeting', this.meeting);
      // Mandar a backend
      try {
        const response = await api.put(`/api/meeting/${this.meeting._id}`, this.meeting, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        console.log('Meeting updated:', response);
      } catch (error) {
        console.error(error);
      }
    },
    async removeParticipant(user) {
      try {
        await api.put(`/api/meeting/${this.meeting._id}`, {invitados: this.meeting.invitados.filter(u => u !== user)});
        window.location.reload();
      } catch (error) {
        console.error('Error al eliminar el participante:', error);
      }
    },
  },
};
</script>

<style scoped>
.fila1 {
  margin-top: 2%;
}

.participant-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
